// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero_wrapper__xT5OJ","content":"hero_content__wyt_T","description":"hero_description__kuKzi"};